<template>
  <component :is="component" v-if="component" :boardData="boardData" :paginationData="paginationData"></component>
</template>

<script>
import EventBus from "@/utils/event-bus";

export default {
  name: "BoardListLink",
  mixins: [],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    listLayout: '',
    boardData: {default: () => {}},
    paginationData: {default: {page: 1, size: 10, total: 0}},
  },
  data() {
    return {
      component: null,
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
    this.loader()
        .then(() => {
          this.component = () => this.loader()
        })
        .catch(() => {
          this.component = () => import('@/template/board/list/BoardListDefaultLayout')
        })
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {
    loader() {
      if (!this.listLayout) {
        return null
      }
      return () => import(`@/template/board/list/${this.listLayout}`)
    },
  },
  methods: {},
  watch: {},
}
</script>

<style scoped>

</style>
